import axios from 'axios';
import { reportClientError } from './errorHandling';

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });
const sessionListeners = new Set();
let refreshing = null;

export function subscribeSessionExpired(listener) {
  sessionListeners.add(listener);
  return () => sessionListeners.delete(listener);
}

export function refreshSession() {
  if (!refreshing) {
    refreshing = api.post('/auth/refresh').finally(() => { refreshing = null; });
  }
  return refreshing;
}

function canRefresh(error) {
  const config = error.config;
  if (!config || config._retry || config.signal?.aborted) return false;
  return error.response?.status === 401 && !config.url?.includes('/auth/');
}

async function retryAuthenticatedRequest(error) {
  if (!canRefresh(error)) return Promise.reject(error);
  const config = { ...error.config, _retry: true };
  try {
    await refreshSession();
  } catch (refreshError) {
    reportClientError('Session refresh failed', refreshError);
    if (refreshError.response?.status === 401) {
      refreshError.code = 'SESSION_EXPIRED';
      sessionListeners.forEach(listener => listener());
    }
    return Promise.reject(refreshError);
  }
  // A replay is attempted only once. Its error must not trigger another refresh.
  return api(config);
}

api.interceptors.response.use(response => response, retryAuthenticatedRequest);

export async function restoreSession() {
  try {
    return (await api.get('/auth/me')).data;
  } catch (error) {
    if (error.response?.status !== 401) throw error;
    return (await refreshSession()).data.user;
  }
}